import HelloJagRun from "../../../../docs/_images/hello_jag_run.png";
import HelloJagWatch from "../../../../docs/_images/hello_jag_watch.png";
import * as React from 'react';
export default {
  HelloJagRun,
  HelloJagWatch,
  React
};